<template>
  <div class="ibox-child">
    <div class="row">
      <div class="form-group col-sm-12 info-status">
        <label class="control-label">{{$t('partnerSettingLabelTitle')}}</label>
        <div class="input-group">
          <span @click="emitPartner" class="form-control cursor">
            <span class="dest-tag dest-active" v-if="!!this.partner">{{getPartnerInfo.userInfo.userName}}<i @click="emitResetPartner" class="fa fa-times cursor"></i></span>
          </span>
          <span class=input-group-btn>
            <button v-if="!this.partner" type="button" @click="emitPartner" class="btn btn-white add-destination"> +</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RegistPartner',
  props: {
    partner: ''
  },
  computed: {
    ...mapGetters('users/', [
      'getUserById'
    ]),
    getPartnerInfo: function () {
      console.log('-----------------', this.getUserById(this.partner))
      return this.getUserById(this.partner)
    }
  },
  methods: {
    emitPartner: function () {
      this.$emit('open-partner', 'partner')
    },
    emitResetPartner: function () {
      this.$emit('reset-partner')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Regist/RegistPartner.vue